import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'plan-pages',
  templateUrl: './plan-pages.component.html',
  styleUrls: ['./plan-pages.component.scss']
})
export class PlanPagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
